<template>
  <li class="splide__slide">
    <slot />
  </li>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'SplideSlide',
};
</script>
